<template>
	<div>
		
		<div class='track__header'>
			<div class='track__title'>Трек файлы</div>
			<!-- <div class='track__button-block'>
				<p-button label='Выбрать все' @click='selectTrackAll' class='p-button-sm p-mr-2'/>
				<p-button label='Удалить выбранные' @click='removeSelectedTrack' class='p-button-sm'/>
			</div> -->
		</div>

		<div class='track__content'>
			<!-- <div v-for='(track, track_i) in trackList' class='track__file-row'>

				<div>{{ track.name }}</div>
				<div><custom-p-checkbox v-model='track.checked'/></div>

			</div> -->

			<table class='track__table'>
				<tbody>
					<tr v-for='(track, track_i) in trackList'>
						<td>{{ track.name }}</td>
						<td><custom-p-checkbox v-model='track.checked' :disabled='!actLpoIsDraft'/></td>
					</tr>
				</tbody>
			</table>


		</div>

		<div class='track__button-block'>
			<p-button label='Выбрать все' icon='fa fa-tasks' @click='selectTrackAll' :disabled='!actLpoIsDraft' class='p-button-sm p-mr-2'/>
			<p-button label='Удалить выбранные' icon='fa fa-trash' :disabled='!selectedTrackList.length || !actLpoIsDraft' @click='removeSelectedTrack' class='p-button-sm p-button-danger'/>
		</div>

	</div>
</template>

<script>
	const ROOT_API = process.env.VUE_APP_ROOT_API;
	const TRACK_REMOVE_IMAGES = ROOT_API + 'load_file/track_remove_files.php';

	export default {
		name: 'ActUploadTrack',

		props: {
			currentLpo: Object,
			trackList: Array
		},

		computed: {
			actLpoIsDraft() { return this.$store.getters['lpoData/actLpoIsDraft']; },

			selectedTrackList() {
				return this.trackList.filter(track => track.checked);
			}
		},

		methods: {
			selectTrackAll() {
				if (!this.trackList.find(item => item.checked === false)) {
					for (let item of this.trackList) {
						item.checked = false;
					}
				} else {
					for (let item of this.trackList) {
						item.checked = true;
					}
				}
			},

			removeSelectedTrack() {
				if (!this.selectedTrackList.length) {
					return;
				}

				const form = new FormData();
				form.append('lpo_id', this.currentLpo.lpo_id);
				form.append('image_list', JSON.stringify(this.selectedTrackList));

				fetch(TRACK_REMOVE_IMAGES, {
					credentials: 'include',
					method: 'post',
					body: form
				})
				.then( res => this.$emit('removed'));
			}
		}
	};
</script>

<style scoped>
	.track__header {
		/*border-bottom: 1px solid black;*/
		/*padding-bottom: 0.5rem;*/
		margin-bottom: 1rem;

		display: flex;
		align-items: flex-end;
		justify-content: space-between;
		flex-wrap: wrap;
		gap: 1rem;

		font-size: 1rem;
		font-weight: bold;
		color: #6c757d;
	}

	.track__content {
/*		display: flex;
		flex-wrap: wrap;
		gap: 1rem;*/
		margin-bottom: 1rem;
	}

	.track__file-row {
		display: flex;
		/*gap: ;*/
	}

	.track__table td {
		vertical-align: middle;
		padding: 0.2rem;
		padding-right: 1rem;
	}
</style>